import {API_ROOT_URL} from 'envs/_current/config'
import {schema} from 'normalizr'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'

export const profileSchema = new schema.Entity(
    'profiles',
    {},
    {
        idAttribute: 'idname',
    }
)
export const profileBiographySchema = new schema.Entity(
    'profile_biographies',
    {},
    {
        idAttribute: 'id',
    }
)


// Route::get('profiles/profile/{id}/get', 'ProfileController@getById');
export const profile_getById_Api = {
    backend: `Route::get('profiles/profile/{id}/get', 'ProfileController@getById');`,
    root: API_ROOT_URL,
    path: '/profiles/profile/:id/get',
    method: 'GET',
    schema: profileSchema,
    transform: createTransform(profileSchema, 'data'),
}
// Route::get('profiles/profile/gets', 'ProfileController@getProfiles');
export const profile_getProfiles_Api = {
    backend: `Route::get('profiles/profile/gets', 'ProfileController@getProfiles');`,
    root: API_ROOT_URL,
    path: '/profiles/profile/gets',
    method: 'GET',
    paramsFields: ['sort_by', 'keyword', 'profile_category',
        'archdiocese_id',
        'diocese_id',
        'deanery_id',
        'parish_id',
        'country_id', 'nationality_id', 'position_title', 'position_group_title', 'feast_state', 'is_holy_doctor', 'is_martyr', 'is_saint', 'is_prelate', 'is_philosopher', 'is_theologian', 'is_musician', 'is_lay_person', 'is_scientist',
        'includes'],
    schema: profileSchema,
    transform: createListTransform(profileSchema),
}

export const profile_getPredecessors_Api = {
    backend: `Route::get('profiles/profile/{id}/get-predecessors', 'ProfileController@getPredecessors');`,
    root: API_ROOT_URL,
    path: '/profiles/profile/:id/get-predecessors',
    method: 'GET',
    paramsFields: ['sort_by', 'keyword'],
    schema: profileSchema,
    transform: createListTransform(profileSchema),
}

// Route::post('profiles/profile/create-new', 'ProfileController@createProfile');
export const profile_createProfile_Api = {
    backend: `Route::post('profiles/profile/create-new', 'ProfileController@createProfile');`,
    root: API_ROOT_URL,
    path: '/profiles/profile/create-new',
    method: 'POST',
    paramsFields: [],
    schema: profileSchema,
    transform: createTransform(profileSchema, 'data'),
}
// Route::post('profiles/profile/{id}/update', 'ProfileController@updateProfile');
export const profile_updateProfile_Api = {
    backend: `Route::post('profiles/profile/{id}/update', 'ProfileController@updateProfile');`,
    root: API_ROOT_URL,
    path: '/profiles/profile/:id/update',
    method: 'POST',
    paramsFields: [],
    schema: profileSchema,
    transform: createTransform(profileSchema, 'data'),
}
// Route::post('profiles/profile/{id}/delete', 'ProfileController@deleteProfile');
export const profile_deleteProfile_Api = {
    backend: `Route::post('profiles/profile/{id}/delete', 'ProfileController@deleteProfile');`,
    root: API_ROOT_URL,
    path: '/profiles/profile/:id/delete',
    method: 'POST',
    paramsFields: [],
    schema: profileSchema,
    transform: createTransform(profileSchema, 'data'),
}


// Route::get('profiles/biography/{id}/get', 'ProfileBiographyController@getById');
export const profileBiography_getById_Api = {
    backend: `Route::get('profiles/biography/{id}/get', 'ProfileBiographyController@getById');`,
    root: API_ROOT_URL,
    path: '/profiles/biography/:id/get',
    method: 'GET',
    schema: profileBiographySchema,
    transform: createTransform(profileBiographySchema, 'data'),
}
// Route::get('profiles/profile/{id}/get-biographies', 'ProfileBiographyController@getProfileBiographies');
export const profileBiography_getBiographies_Api = {
    backend: `Route::get('profiles/profile/{id}/get-biographies', 'ProfileBiographyController@getProfileBiographies');`,
    root: API_ROOT_URL,
    path: '/profiles/profile/:id/get-biographies',
    method: 'GET',
    fields: ['sort_by', 'archdiocese_id',
        'diocese_id',
        'deanery_id',
        'parish_id',
        'country_id',
        'position_title'],
    paramsFields: ['sort_by', 'archdiocese_id',
        'diocese_id',
        'deanery_id',
        'parish_id',
        'country_id',
        'position_title'],
    schema: profileBiographySchema,
    transform: createListTransform(profileBiographySchema),
}

// Route::post('profiles/profile/{id}/create-new', 'ProfileBiographyController@createProfileBio');
export const profileBiography_createProfile_Api = {
    backend: `Route::post('profiles/profile/{id}/add-bio', 'ProfileBiographyController@addProfileBio');`,
    root: API_ROOT_URL,
    path: '/profiles/profile/:id/add-bio',
    method: 'POST',
    paramsFields: [],
    schema: profileBiographySchema,
    transform: createTransform(profileBiographySchema, 'data'),
}
// Route::post('profiles/biography/{id}/update-bio', 'ProfileBiographyController@updateProfileBio');
export const profileBiography_updateProfile_Api = {
    backend: `Route::post('profiles/biography/{id}/update-bio', 'ProfileBiographyController@updateProfileBio');`,
    root: API_ROOT_URL,
    path: '/profiles/biography/:id/update-bio',
    method: 'POST',
    paramsFields: [],
    schema: profileBiographySchema,
    transform: createTransform(profileBiographySchema, 'data'),
}
// Route::post('profiles/biography/{id}/delete-bio', 'ProfileBiographyController@deleteProfileBio');
export const profileBiography_deleteProfile_Api = {
    backend: `Route::post('profiles/biography/{id}/delete-bio', 'ProfileBiographyController@deleteProfileBio');`,
    root: API_ROOT_URL,
    path: '/profiles/biography/:id/delete-bio',
    method: 'POST',
    paramsFields: [],
    schema: profileBiographySchema,
    transform: createTransform(profileBiographySchema, 'data'),
}

export const profile_getProfileRecommendInfo_Api = {
    backend: `Route::get('profiles/recommend-info/get', 'ProfileController@getProfileRecommendInfo');`,
    root: API_ROOT_URL,
    path: '/profiles/recommend-info/get',
    method: 'GET',
    paramsFields: [],
}